// The per-box operator note, and the one cap it is written under.
// Split out of `../runner.ts`, which is now the barrel over this directory.

import { z } from 'zod';

/**
 * Hard cap on a box's operator-authored system prompt (#455). The prompt is a
 * CONCISE briefing — what this VPS runs, which subscription/backend it carries,
 * how work should be dispatched on it — not a second agent template. 2k chars
 * keeps it one tight paragraph-or-three; anything longer belongs in an
 * `agent_templates.system_prompt` (50k). Enforced at EVERY write path
 * ({@link RunnerSystemPromptSchema}: the DB write + the MCP `box set_prompt`
 * verb), never just a UI hint.
 */
export const RUNNER_SYSTEM_PROMPT_MAX_CHARS = 2_000;

/**
 * A NON-EMPTY per-box system prompt at the write boundary (#455): trimmed,
 * 1..{@link RUNNER_SYSTEM_PROMPT_MAX_CHARS} chars. "No prompt" is represented as
 * NULL (clear), never an empty string, so readers branch on one signal.
 */
export const RunnerSystemPromptSchema = z
  .string()
  .trim()
  .min(1)
  .max(RUNNER_SYSTEM_PROMPT_MAX_CHARS);
